import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "plus-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M8.5 3a.5.5 0 0 1 .5.5V8h4.5a.5.5 0 1 1 0 1H9v4.5a.5.5 0 1 1-1 0V9H3.5a.5.5 0 0 1 0-1H8V3.5a.5.5 0 0 1 .5-.5Z" }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
